import { render, staticRenderFns } from "./Jockeys.vue?vue&type=template&id=04b18f2c"
import script from "./Jockeys.vue?vue&type=script&lang=js"
export * from "./Jockeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports